import { invokeApi } from "src/utils";


export const CreateIp = async (data) => {
  const requestObj = {
    path: `admin/security/ip-whitelist`,
    method: "POST",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    postData:data,
  };
  return invokeApi(requestObj);
};
export const GetIPList = async () => {
  const requestObj = {
    path: `admin/security/ip-whitelist`,
    method: "GET",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return invokeApi(requestObj);
};
export const DeleteIP = async (data) => {
  const requestObj = {
    path: `admin/security/ip-whitelist`,
    method: "DELETE",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    postData:data,
  };
  return invokeApi(requestObj);
};